import React from 'react'
import {
	AlertBanner,
	AlertIcon,
	AlertSub,
	AlertTitle,
	CardBody,
	NotesArea,
	NotesLabel,
	NotesWrap,
} from '../ItineraryImportPage.styles'
import { TripSummary } from '../types'
import { FileEntry } from '../utils'
import { AlertCircle } from './icons'
import DropZone from './DropZone'
import FileList from './FileList'
import TripContextStrip from './TripContextStrip'

interface IdleBodyProps {
	trip: TripSummary
	files: FileEntry[]
	notes: string
	isDragOver: boolean
	onNotesChange: (v: string) => void
	onBrowse: () => void
	onRemoveFile: (id: string) => void
	hasValidationErrors: boolean
	validationErrorCount: number
	serverValidationMessage?: string
}

const IdleBody: React.FC<IdleBodyProps> = ({
	trip,
	files,
	notes,
	isDragOver,
	onNotesChange,
	onBrowse,
	onRemoveFile,
	hasValidationErrors,
	validationErrorCount,
	serverValidationMessage,
}) => {
	const alertTitle =
		files.length > 0
			? `${validationErrorCount} of ${files.length} files can't be imported`
			: 'Your import needs attention'

	return (
		<CardBody>
			<TripContextStrip trip={trip} />
			{hasValidationErrors && (
				<AlertBanner>
					<AlertIcon>
						<AlertCircle size={16} strokeWidth={2.3} />
					</AlertIcon>
					<div>
						<AlertTitle>{alertTitle}</AlertTitle>
						<AlertSub>
							{serverValidationMessage ?? 'Fix the issues below or remove them, then continue.'}
						</AlertSub>
					</div>
				</AlertBanner>
			)}
			{files.length === 0 ? (
				<DropZone state={isDragOver ? 'dragOver' : 'idle'} onBrowse={onBrowse} />
			) : (
				<FileList files={files} onRemove={onRemoveFile} onAddMore={onBrowse} />
			)}
			<NotesWrap>
				<NotesLabel htmlFor="import-notes">Or paste text</NotesLabel>
				<NotesArea
					id="import-notes"
					rows={2}
					value={notes}
					onChange={e => onNotesChange(e.target.value)}
					placeholder={'Optional. e.g. "This is from our Paris portion — ignore the Lisbon stuff."'}
				/>
			</NotesWrap>
		</CardBody>
	)
}

export default IdleBody
